/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Modal } from '../../canvasComponents/index';
// scss
import '../../css/components/PopUps/PopUps.scss';
// messages
import messages from './messages';

function NoLongerAvailablePopUp({ open, closePopUp }) {
  return (
    <Modal
      id="fatalityModal"
      isOpen={open}
      ariaHideApp={false}
      onRequestClose={() => closePopUp()}
    >
      <div>
        <div className="pop-up-title">
          <FormattedMessage {...messages.sorryNotAvailable} />
        </div>
        <div className="pop-up-text margin-text-bottom">
          <FormattedMessage {...messages.chooseNewAppointment} />
        </div>
        <Button
          primary
          className="pop-up-btn"
          onClick={() => closePopUp()}
        >
          <FormattedMessage {...messages.okay} />
        </Button>
      </div>
    </Modal>
  );
}

export default injectIntl(NoLongerAvailablePopUp);
